var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"align-center justify-center d-flex",staticStyle:{"cursor":"n-resize","height":"10px","background-color":"transparent"},on:{"mousedown":_vm.startResizeContent}},[_c('v-icon',[_vm._v("mdi-drag-horizontal-variant")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }